import React from "react";

export default function MSAccess_Date() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Date</h1>
      <p>This is the MSAccess_Date component generated from the SQL JSON.</p>
    </div>
  );
}
